export const customStyles = {
  overlay: {
    backgroundColor: "rgb(36, 36, 36, 0.80)",
    zIndex: 2,
  },
};

export const customStylesHighZIndex = {
  overlay: {
    backgroundColor: "rgb(36, 36, 36, 0.80)",
    zIndex: 9999,
  },
};

// EXCLUSIVE: Use only for the Session Timeout Modal.
// Do not reuse this style for any other modal/component.
export const customStylesSessionModal = {
  overlay: {
    backgroundColor: "rgb(36, 36, 36, 0.80)",
    // Very high to ensure session timeout modal is always on top
    zIndex: 10000000,
  },
};
